import { capitalize, constantCase } from '@art-suite/art-core-ts';

export const truncateWithEllipsis = (text: string, maxLength: number): string => text.length <= maxLength ? text : text.slice(0, maxLength - 1).trimEnd() + '…';

/** A name from the code as words, in sentence case: taskDescription → "Task description". */
export const presentCodeNameAsWords = (codeName: string) => capitalize(constantCase(codeName, ' ').toLowerCase());
